<template>
  <div class="DETAIL-ITEM">
    <label class="DETAIL-ITEM-LABEL">
      <slot name="label">
        {{ itemLabel }}
      </slot>
    </label>
    <div :selenium="itemSelenium" class="DETAIL-ITEM-VALUE">
      <slot name="value">
        {{ itemValue }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'detail-item',
  props: {
    itemLabel: {
      type: String,
      default: '',
    },
    itemValue: {
      type: [String, Number],
      default: '',
    },
    itemSelenium: {
      type: String,
      default: '',
    },
  },
};
</script>


<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.DETAIL-ITEM {
  @include padding(2);
  display: grid;
  grid-template:  'label' auto
                  'value' 1fr /
                   1fr;
  grid-column-gap: $unit;
}

.DETAIL-ITEM-LABEL {
  font-weight: bold;
  color: $color-gray90;
  grid-area: label;
}

.DETAIL-ITEM-VALUE {
  color: $color-gray70;
  grid-area: value;
}
</style>
